














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Based off of idea from https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d
@Component
export default class AlertDialog extends Vue {
  showDialog: boolean = false;
  title: string = '';
  message: string = '';
  defaultOptions: any = {
    width: 400,
  };
  options: any = {};
  titleClass: string = "modal-title";
  bodyClass: string = "modal-body pt-5";

  // TODO: Could add options for other things besides the dialog

  resolve: (value?: void | PromiseLike<void> | undefined) => void = () => {};
  reject: (value?: void | PromiseLike<void> | undefined) => void = () => {};

  public open(message: string, title: string = '', options: any = {}): Promise<void> {
    this.showDialog = true;
    this.title = title;
    this.message = message;
    this.options = Object.assign({}, this.defaultOptions, options);
    if (this.options.isError) {
     this.titleClass = "modal-title-error";
    }
    if (title) {
      this.bodyClass = "modal-body";
    }
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private async close() {
    await this.resolve();
    this.reset();
  }

  private reset() {
    this.showDialog = false;
    this.title = '';
    this.message = '';
    this.options = {};
    this.resolve = () => {};
    this.reject = () => {};
  }
}
